import { render, staticRenderFns } from "./CantidadRNRXArea.vue?vue&type=template&id=558d9979&scoped=true&"
import script from "./CantidadRNRXArea.vue?vue&type=script&lang=js&"
export * from "./CantidadRNRXArea.vue?vue&type=script&lang=js&"
import style0 from "./CantidadRNRXArea.vue?vue&type=style&index=0&id=558d9979&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558d9979",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
